import axios, { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';
import { API_CONFIG, logApiCall, logApiResponse, logApiError } from '../config/apiConfig';
import { ApiResponse, ApiRequestConfig } from '../types/api.d';
// Create axios instance with base configuration (always real API)
const api: AxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

// Request interceptor to attach JWT token
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const method = config.method || 'UNKNOWN';
    // Do NOT attach Authorization for public auth endpoints
    const noAuthPaths = [
      '/api/User/login',
      '/api/User/createUser',
      '/api/User/sendOTP',
      '/api/User/activateUser',
      '/auth/login',
      '/auth/register'
    ];

    const shouldAttachAuth = !noAuthPaths.some((p) => url.startsWith(p));

    if (shouldAttachAuth) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // Log API calls in development
    logApiCall(method , url, config.data);

    return config;
  },
  (error) => {
    logApiError('REQUEST', 'Unknown', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    // Log successful responses in development
    logApiResponse(response.config.method || 'UNKNOWN', response.config.url || 'UNKNOWN', response.data);
    return response;
  },
  (error) => {
    // Log errors in development
    logApiError(
      error.config?.method || 'UNKNOWN', 
      error.config?.url || 'Unknown', 
      error
    );
    
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Do NOT redirect for public auth endpoints (let UI show inline error)
      const publicAuthPaths = [
        '/api/User/login',
        '/api/User/createUser',
        '/api/User/sendOTP',
        '/api/User/activateUser',
        '/auth/login',
        '/auth/register'
      ];
      const isPublicAuth = publicAuthPaths.some((p) => url.startsWith(p));

      if (!isPublicAuth) {
        // Clear token and redirect to login for protected routes only
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
